// extracted by mini-css-extract-plugin
module.exports = {"add-news__form":"AddNews_add-news__form__2K2-3","msg-error":"AddNews_msg-error__1Q_e9","invalid":"AddNews_invalid__3lxDg","input-message":"AddNews_input-message__1YoLq"};